export default __webpack_public_path__ + "static/media/grafema_SET_23.63193efb.jpg";